import React, { useState, useContext } from 'react'
import { useHistory, Link } from "react-router-dom";
import { Form, Button } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';

import api          from '../../services/api';
import StoreContext from '../storage/context';
import AlertCustom  from '../alertCustom/index.js'
import BtnLoader    from '../buttons/loader/index.js'

// schema validation
import * as schema  from '../schemaValidation/index.js'


import './styles.css'

import logoNatura from '../../assets/logo-natura-black.svg'
import background from '../../assets/background-page-login.jpg'

// define a tela de login da aplicação
const SignIn = () => {
    // restaga o token obtido no contexto StoreContext
    const { token, setToken, pk_user, setPKUser, setDisplayName, setGivenName, setRACF } = useContext(StoreContext);
    const history = useHistory();

    const [alert, setAlert] = useState({header: '', message: '', type: '', options_btn: []});
    const [showAlert, setShowAlert] = useState(false);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const dateCurrent = new Date();

    // submete o formulário de login 
    const submitSignUp = (pk_user, password) => {
        setLoading(true)
        api.post('accounts/login', {
            'pk_user': pk_user, 
            'password': password
        })
        .then(response => {
            // save variables for context storage
            const data = response.data

            setToken(data.token)
            setPKUser(data.pk_user)

            if (data.token) {
                setDisplayName(data.full_name)
                setGivenName(data.given_name)
                setRACF(data.racf)

                history.push('/')
            } else {
                setMessage(data.message)
            }

            setLoading(false)
        })
        .catch(error => {
            const message =  error.response ? error.response.data.message : error
            setMessage(message)
            setLoading(false)
        })
    }


    return (
        <div className="signup-container-first">
            {/* ALERT CUSTOM */}
            <AlertCustom showAlert={showAlert} setShowAlert={setShowAlert} alert={alert} />

            <div className="signup-container" style={{ backgroundImage: `url(${background})` }}>

                <Formik
                    initialValues={{ pk_user: '', password: '' }}
                    validationSchema={schema.LoginSchema}
                    onSubmit={(values) => submitSignUp(values.pk_user, values.password)}
                    validateOnChange={false}
                    validateOnBlur={false}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        values,
                        touched,
                        isValid,
                        errors,
                    }) => (
                        <Form className="signup-container-form" noValidate onSubmit={handleSubmit}>
                            <div className="signup-container-logo">
                                <img className="signup-logo" src={logoNatura} />
                            </div>
                            
                            <Form.Group className="mb-3" controlId="pk_user">
                                <Form.Label>E-mail corporativo</Form.Label>
                                <Form.Control 
                                    type="text"
                                    name="pk_user"
                                    placeholder="Digite seu e-mail corporativo"
                                    value={values.pk_user}
                                    onChange={handleChange}
                                    isInvalid={!!errors.pk_user}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.pk_user}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label>Senha</Form.Label>
                                <Form.Control
                                    type="password"
                                    name="password"
                                    placeholder="Digite sua senha"
                                    value={values.password}
                                    onChange={handleChange} 
                                    isInvalid={!!errors.password}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.password}
                                </Form.Control.Feedback>
                            </Form.Group>

                            {message ? <p className='signin-alert-message'>{message}</p> : null}

                            <div className="d-grid gap-2">
                                <BtnLoader
                                    loading={loading}
                                    messageNotLoading="ACESSAR"
                                    messageLoading="ACESSANDO"
                                    style={"btn-loader-100-porcent"}
                                    variant={"primary"}
                                />
                            </div>

                            <div className="signup-container-help">
                                <Link to="/faq" className="signup-faq">FAQ</Link>
                            </div>

                            <div className="signup-container-header">
                                <h1 className="signup-h1">CoE Dados</h1>
                                <p className="signup-p">Natura &Co © {dateCurrent.getFullYear()}</p>
                            </div>
                        </Form>
                    )}

                </Formik>

            </div>
        </div>
    );
}

export default SignIn;